import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import loadAllTerms from "@tKgpco/Handlers/Terms/LoadTerms";
import searchFilterTerms from "@tKgpco/Handlers/Terms/SearchFilterTerms";
import { deleteTerm } from "@tKgpco/Services/TermsService";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";
import { QuoteTerm } from "@tKgpco/Store/Data/Terms/TermsState";

type Parameters = { id: string } & HasOnSuccess & HasOnError;
type HandlerType = CustomApiHandler<Parameters, QuoteTerm>;

export const BeginDeleteTerm: HandlerType = props => {
    props.dispatch({ type: "Custom/Terms/ShowOverlay" });
};

export const RequestDataFromApi: HandlerType = props => {
    return deleteTerm(props.parameter.id);
};

export const LoadTerms: HandlerType = props => {
    props.dispatch(searchFilterTerms({ queryParams: { page: 1 } }));
};

export const CompleteDeleteTerm: HandlerType = props => {
    props.dispatch({
        type: "Custom/Terms/HideOverlay",
    });
};

export const ExecuteOnSuccess: HandlerType = props => {
    props.parameter.onSuccess?.();
};

export const chain = [
    BeginDeleteTerm,
    RequestDataFromApi,
    LoadTerms,
    CompleteDeleteTerm,
    ExecuteOnSuccess,
];

const removeTerm = createHandlerChainRunner(chain, "CustomLoadTerm");
export default removeTerm;
